import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=ecdf46bc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecdf46bc')) {
      api.createRecord('ecdf46bc', component.options)
    } else {
      api.reload('ecdf46bc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=ecdf46bc&", function () {
      api.rerender('ecdf46bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Fh6gBCI58yCo/JS/offershelp.vue"
export default component.exports